import {
  ACCOUNTS_STORAGE_KEY,
  ORGANISATION_STORAGE_KEY,
  ROLES,
  setHeaderFilterPermissions,
} from '@data-access';

import { canAccess } from './can-access';
import { Permission } from './permission';

function clearStoredFilter(key: string) {
  localStorage.setItem(key, '[]');
}

/** Syncs header filter permissions from role rules and clears stale localStorage filters. */
export function syncHeaderFilters(role: ROLES | undefined): void {
  const organisation = canAccess(role, Permission.OrganisationSelector);
  const accounts = canAccess(role, Permission.AccountsSelector);

  setHeaderFilterPermissions({ organisation, accounts });

  if (!organisation) {
    clearStoredFilter(ORGANISATION_STORAGE_KEY);
  }

  if (!accounts) {
    clearStoredFilter(ACCOUNTS_STORAGE_KEY);
  }
}
